export const STORE_SUBMISSION_ERRORS = 'submission/STORE_SUBMISSION_ERRORS';
